import { t } from "@shared/utils/internationalization";
import yup from "@shared/lib/yupExtensions/index";
import { PhoneCountryType } from "@shared/lib/libphonenumber/api";

export const guestCheckoutSchema = (phoneCountry: PhoneCountryType) =>
  yup.object().shape({
    name: yup
      .string()
      .required(t("Name is required"))
      .test(
        "has-first-and-last-name",
        t("Both first and last names are required"),
        (value) => {
          if (!value) return false;
          const words = value.trim().split(/\s+/);
          return words.length >= 2;
        }
      ),
    email: yup
      .string()
      .required(t("Email is required"))
      .email(t("Invalid email address")),
    phone: yup
      .string()
      .required(t("Phone number is required"))
      .phone(t("Invalid phone number for selected country"), phoneCountry),
  });
